import {z} from 'zod'

export const stockSourceRawFields = {
    party: z.enum(['first_party', 'third_party']).optional(),
    third_party_rental_asset_offering_id: z.string().nullish(),
    third_party_rental_company_id: z.string().nullish(),
    third_party_rental_company_name: z.string().nullish(),
}

export type StockSource = {
    party?: 'first_party' | 'third_party'
    thirdPartyRentalAssetOfferingId?: string | null
    thirdPartyRentalCompanyId?: string | null
    thirdPartyRentalCompanyName?: string | null
}

export function mapStockSource(
    raw: z.infer<z.ZodObject<typeof stockSourceRawFields>>,
): StockSource {
    return {
        party: raw.party ?? 'first_party',
        thirdPartyRentalAssetOfferingId: raw.third_party_rental_asset_offering_id ?? null,
        thirdPartyRentalCompanyId: raw.third_party_rental_company_id ?? null,
        thirdPartyRentalCompanyName: raw.third_party_rental_company_name ?? null,
    }
}

export function stockSourceKey(source: StockSource & {rentalAssetTypeId: string}): string {
    return `${source.rentalAssetTypeId}-${source.thirdPartyRentalAssetOfferingId ?? 'owned'}`
}
